import React from 'react';
import { ProposalStatus } from '../api/proposalApi';

interface Props {
  status: ProposalStatus;
}

export default function ProposalStatusBadge({ status }: Props) {
  const configs: Record<ProposalStatus, { label: string; className: string }> = {
    [ProposalStatus.Draft]: { label: 'Draft', className: 'bg-slate-100 text-slate-600 border-slate-200' },
    [ProposalStatus.Sent]: { label: 'Sent', className: 'bg-blue-50 text-blue-600 border-blue-100' },
    [ProposalStatus.Accepted]: { label: 'Accepted', className: 'bg-emerald-50 text-emerald-600 border-emerald-100' },
    [ProposalStatus.Declined]: { label: 'Declined', className: 'bg-red-50 text-red-600 border-red-100' },
    [ProposalStatus.Expired]: { label: 'Expired', className: 'bg-amber-50 text-amber-600 border-amber-100' },
  };

  const config = configs[status];

  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold border ${config.className}`}>
      {config.label}
    </span>
  );
}